import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Feature from "../components/feature"
import SEO from "../components/seo"
import ObviousThumbnail from "../images/obvious_thumbnail.jpg"
import CheckoutThumbnail from "../images/obviouscheckout_thumbnail.jpg"
import NordicCustomerSupportThumbnail from "../images/nsccsa_thumbnail.jpg"
import FouriThumbnail from "../images/4iiii_thumbnail.jpg"
import SPSiloThumbnail from "../images/sp_silo_thumbnail.jpg"
import SPSMThumbnail from "../images/sp_sm_thumbnail.jpg"
import SPCheckoutThumbnail from "../images/sp_checkout_thumbnail.jpg"
import FundwallThumbnail from "../images/fundwall_thumbnail.jpg"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className="min-h-screen py-16 w-full">
      <div className="max-w-screen-lg mx-auto px-6 text-indigo-100">
        <div className="px-6 max-w-screen-md mx-auto text-center">
          <h1 className="text-5xl font-bold leading-tight mb-4">
            Hello, my name is <span className="text-teal-400">Tyler</span>.
          </h1>
          <p className="leading-loose">
            I'm a Designer and Developer from Cochrane, Alberta. I like to
            develop beautiful, intuitive experiences through thoughtful design
            and accessible code.
          </p>
        </div>
        <div className="px-3 py-12">
          <div className="flex flex-wrap -mx-3">
            <Feature
              title="Obvious Portal"
              subtitle="Obvious."
              graphic={ObviousThumbnail}
              location="/obvious"
            />
            <Feature
              title="Obvious Checkout"
              subtitle="Obvious."
              graphic={CheckoutThumbnail}
              location="/obvious-checkout"
            />
            <Feature
              title="Customer Support Tool"
              subtitle="Nordic Semiconductor"
              graphic={NordicCustomerSupportThumbnail}
              location="/nordic-customer-support"
            />
            <Feature
              title="Ecommerce Website"
              subtitle="4iiii"
              graphic={FouriThumbnail}
              location="/4iiii"
            />
            <Feature
              title="Silo Page"
              subtitle="Samritan's Purse"
              graphic={SPSiloThumbnail}
              location="/sp-silo"
            />
            <Feature
              title="Sponsor Me"
              subtitle="Samritan's Purse"
              graphic={SPSMThumbnail}
              location="/sp-sponsorme"
            />
            <Feature
              title="Checkout"
              subtitle="Samritan's Purse"
              graphic={SPCheckoutThumbnail}
              location="/sp-checkout"
            />
            <Feature
              title="Fund Wall"
              subtitle="Nodano"
              graphic={FundwallThumbnail}
              location="/nodano-fundwall"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
